export default __webpack_public_path__ + "static/media/OrderSuccess.61d8fb65.svg";